var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTextbox',{attrs:{"label":"Input with maximum 20 characters","maxlength":20}})
}
var staticRenderFns = []

export { render, staticRenderFns }